import * as React from "react"

function CartIcon(props) {
  return (
    <svg
      width={35}
      height={35}
      viewBox="0 0 60 45.3"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{"Cart"}</title>
      <path d="M34.4 19.6h.6l14.6-8.2c.4-.2.4-.8 0-1.1l-.8-.5a.6.6 0 0 0-.6 0l-15.4 8.7c.4.5 1.1.7 1.6 1.1zM53.7 18.8a.6.6 0 0 0-.6 0L23.3 36l1 1.4c.2.3.5.4.8.2l29.2-16.9c.3-.1.5-.4.6-.7 0-.2 0-.4-.2-.5l-1-.7zM26.5 14.8h.6l14.6-8.2c.4-.2.4-.8 0-1.1l-.8-.5a.6.6 0 0 0-.6 0l-14.6 8.2c-.4.2-.4.8 0 1 .3.3.5.5.8.6zM30.5 17.2h.6L45.7 9c.4-.2.4-.8 0-1.1l-.8-.5a.6.6 0 0 0-.6 0l-15.5 8.7 1.7 1.1z"/><path d="M59.9 20.4a8.8 8.8 0 0 0-3.9-5.8c-.4-.3-.4-.8 0-1l2.2-1.3c.5-.3.9-.9.9-1.5v-.1c0-.6-.3-1.2-.9-1.5L43.5.8C42.1 0 40.3-.4 38.8.5l-37 21.4c-.9.5-1.5 1.5-1.7 2.5a10 10 0 0 0 .5 5.7c1 2.4 2.4 4.7 4.4 6.4.9.8 2 1.4 3 2l10.8 6.2c.6.4 1.3.6 2.1.6h.1c.7-.1 1.3-.5 1.9-.9L59 23.5c1-.6 1.1-2 .9-3.1zm-53.3.9L38.3 2.9c1.6-1 3.7-1 5.3-.1l12.8 7.4c.4.2.4.8 0 1.1L22.3 31h-.6L7.9 23l-1.2-.7c-.5-.2-.5-.8-.1-1zm14 21.5c-.6.4-1.4.1-1.9-.2l-12.1-7A9.8 9.8 0 0 1 3 31.4a8 8 0 0 1-1-5c.1-1 .6-2 1.6-2.4 1-.4 2.1-.2 3 .3l3.3 1.9c.4.2.4.8 0 1.1l-2.2 1.3c-.5.3-.8.9-.9 1.5v.1c0 .6.3 1.2.8 1.5L18.5 38a5 5 0 0 1 2.5 3.2c.1.5.1 1.2-.4 1.6zm36.8-20.7c-.7.7-1.6 1.2-2.4 1.6L23.6 41.8c-.4.2-.8 0-.9-.4a8.9 8.9 0 0 0-4.5-5.8l-8.8-5.1c-.4-.2-.4-.8 0-1.1l2.7-1.6h.6l9.3 5.3 31-17.9h.6l2.1 1.2c1.2.7 2.1 1.8 2.4 3.2.2 1-.1 1.9-.7 2.5z"/><path d="m22.8 26.4 9-5c.4-.2.4-.8 0-1.1l-8.7-5.2a.6.6 0 0 0-.6 0l-9.9 5.5 9.6 5.7c.2.2.4.2.6.1z"/>
    </svg>
  )
}

export default CartIcon
